<div class="document-preview-modal">
  <div class="document-preview-modal-header">
    <h3 class="title">Перегляд документа</h3>

    <button mat-button
            mat-icon-button
            aria-label="close modal"
            matDialogClose>
      <mat-icon class="material-icons_grey">close</mat-icon>
    </button>
  </div>

  <div class="document-preview-modal-content">
    <img class="image" [src]="safeUrl" alt="">
  </div>
</div>
